import styled from "styled-components";
import { media } from "src/layouts/utils";
import { TituloDestaque } from "src/layouts/Default";
import { Sorriso } from "../../../../components/TituloSorriso/styles";
import { isIOS, isMacOs } from "react-device-detect";
//import { Button } from "veloe-ds";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("/bradescoexclusive/assets/MotivosBackground2x.png") no-repeat;
  background-size: 75%, contain;
  background-position: top right;
  background-color: #ecedef;
  padding: 64px 0;
  gap: 2.5rem;

  ${media.desktop`
    height: fit-content; 
    background-image: none;
    padding: 32px 0;
    gap: 1.5rem;
  `}
`;

export const Container = styled.div`
  display: flex;
  width: 80%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  @media only screen and (max-width: 1100px) and (min-width: 1000px) {
    width: 90%;
  }

  ${media.desktop`
    display: block;
    width: 100%;
    padding: 5px;
    margin: 0;
    text-align: center;
  `}
`;

export const Title = styled(TituloDestaque)`
  font-size: 32px;
  line-height: 42px;
  padding: 0;
  background: none;

  ${media.phone`
    font-size: 2.5rem;
    line-height: 2.7rem;
    padding: 0 24px 5px;
    width: 100%;
  `}
`;

export const IconSorriso = styled(Sorriso)`
  margin-bottom: 0;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CustomButtom = styled.button`
  font-family: "Work Sans" !important;
  font-weight: 700;
  .label {
    ${(isIOS || isMacOs) &&
      `
      top: 0;
    `}
  }
  ${media.phone`
    width: 134px !important;
`}
  ${media.smallPhone`
  width: 134px !important;
  `}
`;
